
















import Vue from 'vue';
import LiquorTree from 'liquor-tree';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { TreeViewHeader } from '@/components/shared';
import { TreeViewHelpers } from '@/mixins/treeView';
import { mapActions, mapGetters } from 'vuex';
import { ObjectUtils } from '@/utils/objectUtils';
Vue.use(LiquorTree);

export default Vue.extend({
  name: 'ConfigurationTreeView',
  mixins: [TreeViewHelpers],
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      options: {
        checkbox: false,
        parentSelect: true
      }
    };
  },
  methods: {
    ...mapActions('configurationStore', ['getConfigurationTree', 'resetSelectedNodeToExpandOnMount']),
    async getTreeData() {
      try {
        this._isLoading = true;
        if (this.configurationTree == null || this.configurationTree.length === 0) {
          await this.getConfigurationTree();
        }
      } catch (error) {
        this.$log('Failed to get configuration tree', error);
      } finally {
        this._isLoading = false;
      }
    },
    navigate(node: any) {
      if (
        node.data.treeNodePath &&
        node.data.treeNodePath.localeCompare(this.$router.currentRoute.path) &&
        this.$router.currentRoute.path !== this.$router.resolve({ name: node.data.routeName, params: node.data.routeParameters ?? {} }).route.path
      ) {
        this.$router.push({ name: node.data.routeName, params: node.data.routeParameters ?? {} });
      } else {
        node.states.expanded = !node.states.expanded;
      }
    },
    getNode(this: any, tree: any) {
      let node;
      if (this.$route.meta.treePath) {
        node = tree.find({
          data: { treeNodePath: this.$route.meta.treePath }
        });
      } else {
        node = tree.find({
          data: { treeNodePath: this.$route.path }
        });
      }

      if (!node) {
        return;
      }
      this.selectNode(node);
      if (this.expandSelectedNodeOnMount) {
        this.expandNode(node);
        this.resetSelectedNodeToExpandOnMount();
      }
    }
  },
  watch: {
    '$route.fullPath'(this: any) {
      this.getNode(this.$refs.tree);
    },
    // tslint:disable-next-line:object-literal-key-quotes
    configurationTree: {
      handler(this: any, incoming) {
        if (this.PreviousConfigurationTree) {
          this.addNewNodesToTree(incoming, this.PreviousConfigurationTree);
          this.removeDeletedNodesFromTree(incoming, this.PreviousConfigurationTree);
        }

        this.PreviousConfigurationTree = ObjectUtils.deepCloneObject(incoming);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('configurationStore', ['configurationTree', 'expandSelectedNodeOnMount']),
    _isLoading: {
      get(this: any) {
        return this.loading;
      },
      set(this: any, value: boolean) {
        this.$emit('update:loading', value);
      }
    }
  },
  async mounted(this: any) {
    await this.getTreeData();
    this.scrollSelectedNodeIntoView();
    this.PreviousConfigurationTree = ObjectUtils.deepCloneObject(this.configurationTree);
  },
  created(this: any) {
    this.scrollIntoViewOnUpdated = false;
  },
  components: {
    LoadingSpinner,
    TreeViewHeader
  }
});
